import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { t as translate, resolveLanguage } from '../utils/translations';
import { useAuth } from './AuthContext';

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const { user } = useAuth();
  const [preference, setPreference] = useState('auto');

  // Sync with user profile
  useEffect(() => {
    if (user?.language) {
      setPreference(user.language);
    }
  }, [user?.language]);

  const resolved = resolveLanguage(preference);

  // Set HTML lang attribute
  useEffect(() => {
    document.documentElement.lang = resolved;
  }, [resolved]);

  const t = useCallback((key, replacements) => {
    return translate(key, preference, replacements);
  }, [preference]);

  return (
    <LanguageContext.Provider value={{ preference, setPreference, resolved, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    // Fallback for components outside provider
    return {
      preference: 'auto',
      setPreference: () => {},
      resolved: 'en',
      t: (key) => translate(key, 'en'),
    };
  }
  return context;
}
